import { axiosGet, axiosPut } from '../axios/httpRequest';

/**
 * 修改系统配置
 */
export const putConfigApi = params => {
    return axiosPut(`api/systemConfig/v1/info`, params);
};

/**
 * 获取系配置
 */
export const getConfigApi = params => {
    return axiosGet(`api/systemConfig/v1/info`, params);
};
